const arr = [
  { text: "Anse Ger Secondary School, Micoud", value: "school_1" },
  { text: "Babonneau Secondary School, Babonneau", value: "school_2" },
  { text: "Bocage Secondary School, Bocage, Castries", value: "school_3" },
  {
    text: "Beanfield Comprehensive Secondary School, Vieux Fort",
    value: "school_4",
  },
  { text: "Bonne Terre Preparatory School", value: "school_5" },
  {
    text: "Castries Comprehensive Secondary School, Vide Boutielle, Castries",
    value: "school_6",
  },
  {
    text: "Choiseul Secondary School, La Fargue, Choiseul",
    value: "school_7",
  },
  { text: "Ciceron Secondary School, Ciceron, Castries", value: "school_8" },
  {
    text: "Clendon Mason Memorial Secondary School, Dennery",
    value: "school_9",
  },
  {
    text: "Corinth Secondary School, Corinth, Gros Islet",
    value: "school_10",
  },
  { text: "Entrepot Secondary School, Castries", value: "school_11" },
  {
    text: "George Charles Secondary School, Cul de Sac, Castries",
    value: "school_12",
  },
  {
    text: "Grande Riviere Secondary School, Grande Riviere, Dennery",
    value: "school_13",
  },
  {
    text: "Gros Islet Secondary School, Beausejour, Gros Islet",
    value: "school_14",
  },
  {
    text:
      "International School St. Lucia (private, Canadian), Rodney Heights, Gros Islet",
    value: "school_15",
  },
  {
    text:
      "Jon Odlum Secondary School (formerly Marigot Secondary School), Marigot, Castries",
    value: "school_16",
  },
  {
    text: "Leon Hess Comprehensive Secondary School, Entrepot, Castries",
    value: "school_17",
  },
  { text: "Micoud Secondary School, Micoud", value: "school_18" },
  { text: "Piaye Secondary School, Piaye, Laborie", value: "school_19" },
  {
    text: "Saint Lucia Seventh Day Adventist Academy, Sunny Acres, Castries",
    value: "school_20",
  },
  { text: "St. Joseph's Convent, Cedars, Castries", value: "school_21" },
  { text: "St. Mary's College, Vigie, Castries", value: "school_22" },
  {
    text: "Sir Ira Simmons Secondary School, Vide Boutielle, Castries",
    value: "school_23",
  },
  {
    text: "Soufriere Comprehensive Secondary School, Soufriere",
    value: "school_24",
  },
  {
    text: "Vide Bouteille Secondary School, La Clery, Castries",
    value: "school_25",
  },
  {
    text: "Vieux Fort Comprehensive Secondary School, Vieux Fort",
    value: "school_26",
  },
];

// const newArr = arr.map(({ text }) => {
//   let val = text.replace(/[^\w\s]/gi, "_");
//   val = val.replace(/ /g, "_");
//   val = val.split("___").join("_");
//   val = val.split("__").join("_");

//   return {
//     text: text,
//     value: val.toLowerCase(),
//   };
// });

// console.log(newArr);

export default [
  {
    text: "Anse Ger Secondary School, Micoud",
    value: "anse_ger_secondary_school_micoud",
  },
  {
    text: "Babonneau Secondary School, Babonneau",
    value: "babonneau_secondary_school_babonneau",
  },
  {
    text: "Bocage Secondary School, Bocage, Castries",
    value: "bocage_secondary_school_bocage_castries",
  },
  {
    text: "Beanfield Comprehensive Secondary School, Vieux Fort",
    value: "beanfield_comprehensive_secondary_school_vieux_fort",
  },
  {
    text: "Bonne Terre Preparatory School",
    value: "bonne_terre_preparatory_school",
  },
  {
    text: "Castries Comprehensive Secondary School, Vide Boutielle, Castries",
    value: "castries_comprehensive_secondary_school_vide_boutielle_castries",
  },
  {
    text: "Choiseul Secondary School, La Fargue, Choiseul",
    value: "choiseul_secondary_school_la_fargue_choiseul",
  },
  {
    text: "Ciceron Secondary School, Ciceron, Castries",
    value: "ciceron_secondary_school_ciceron_castries",
  },
  {
    text: "Clendon Mason Memorial Secondary School, Dennery",
    value: "clendon_mason_memorial_secondary_school_dennery",
  },
  {
    text: "Corinth Secondary School, Corinth, Gros Islet",
    value: "corinth_secondary_school_corinth_gros_islet",
  },
  {
    text: "Entrepot Secondary School, Castries",
    value: "entrepot_secondary_school_castries",
  },
  {
    text: "George Charles Secondary School, Cul de Sac, Castries",
    value: "george_charles_secondary_school_cul_de_sac_castries",
  },
  {
    text: "Grande Riviere Secondary School, Grande Riviere, Dennery",
    value: "grande_riviere_secondary_school_grande_riviere_dennery",
  },
  {
    text: "Gros Islet Secondary School, Beausejour, Gros Islet",
    value: "gros_islet_secondary_school_beausejour_gros_islet",
  },
  {
    text:
      "International School St. Lucia (private, Canadian), Rodney Heights, Gros Islet",
    value:
      "international_school_st_lucia_private_canadian_rodney_heights_gros_islet",
  },
  {
    text:
      "Jon Odlum Secondary School (formerly Marigot Secondary School), Marigot, Castries",
    value:
      "jon_odlum_secondary_school_formerly_marigot_secondary_school_marigot_castries",
  },
  {
    text: "Leon Hess Comprehensive Secondary School, Entrepot, Castries",
    value: "leon_hess_comprehensive_secondary_school_entrepot_castries",
  },
  {
    text: "Micoud Secondary School, Micoud",
    value: "micoud_secondary_school_micoud",
  },
  {
    text: "Piaye Secondary School, Piaye, Laborie",
    value: "piaye_secondary_school_piaye_laborie",
  },
  {
    text: "Saint Lucia Seventh Day Adventist Academy, Sunny Acres, Castries",
    value: "saint_lucia_seventh_day_adventist_academy_sunny_acres_castries",
  },
  {
    text: "St. Joseph's Convent, Cedars, Castries",
    value: "st_joseph_s_convent_cedars_castries",
  },
  {
    text: "St. Mary's College, Vigie, Castries",
    value: "st_mary_s_college_vigie_castries",
  },
  {
    text: "Sir Ira Simmons Secondary School, Vide Boutielle, Castries",
    value: "sir_ira_simmons_secondary_school_vide_boutielle_castries",
  },
  {
    text: "Soufriere Comprehensive Secondary School, Soufriere",
    value: "soufriere_comprehensive_secondary_school_soufriere",
  },
  {
    text: "Vide Bouteille Secondary School, La Clery, Castries",
    value: "vide_bouteille_secondary_school_la_clery_castries",
  },
  {
    text: "Vieux Fort Comprehensive Secondary School, Vieux Fort",
    value: "vieux_fort_comprehensive_secondary_school_vieux_fort",
  },
];
